/* global Tena */

(function($) {
    Tena.PushBox = {
        pushBoxHeight: null,
        pushBoxMaxHeight: null,
        resolutions: [
            { bp: 1528, maxHeight: 460 },
            { bp: 1222, maxHeight: 420 },
            { bp: 992, maxHeight: 310 },
            { bp: 768, maxHeight: 400 },
            { bp: 570, maxHeight: 380 },
            { bp: 0, maxHeight: 200 }
        ],

        init: function() {
            // Tena.PushBox.setPushBoxHeight();
            // Tena.PushBox.bindEvents();
        },

        bindEvents: function() {
            $(window).resize(Tena.PushBox.setPushBoxHeight);
        },

        calculateMaxHeight: function() {
            var windowWidth = $(window).width(),
                maxHeight = 460;

            for (var resolution in Tena.PushBox.resolutions) {
                if (Tena.PushBox.resolutions[resolution].bp < windowWidth) {
                    maxHeight = Tena.PushBox.resolutions[resolution].maxHeight;
                    break;
                }
            }
            Tena.PushBox.pushBoxMaxHeight = maxHeight;
        },

        setPushBoxHeight: function() {
            var $pushBox = $('.push-box-content'),
                $this,
                height;

            Tena.PushBox.calculateMaxHeight();

            $pushBox.each(function() {
                height = Tena.PushBox.pushBoxHeight;
                $this = $(this);

                if ($this.hasClass('standard')) {
                    $this.css('min-height', 'auto');
                    if (height === null || height < $this.outerHeight()) {
                        Tena.PushBox.pushBoxHeight = $this.outerHeight();
                    }
                }
            });
            if (Tena.PushBox.pushBoxHeight < Tena.PushBox.pushBoxMaxHeight) {
                $pushBox.css({ 'min-height': Tena.PushBox.pushBoxMaxHeight });
            } else {
                $pushBox.css({ 'min-height': Tena.PushBox.pushBoxHeight });
            }
        }
    };
})(jQuery);
